
import { AppState } from '@/types';
import { createActivityActions } from './actions/activityActions';
import { createUserActions } from './actions/userActions';
import { createPetCollectionActions } from './actions/petCollectionActions';
import { createChallengeActions } from './actions/challengeActions';
import { createStatsActions } from './actions/statsActions';
import { createPrizeActions } from './actions/prizeActions';
import { createHabiticaActions } from './actions/habiticaActions';
import { createPledgeBasedPetActions } from './actions/pledgeBasedPetActions';

export const createActions = (state: AppState, dispatch: any, setAppState: any) => {
  const activityActions = createActivityActions(state, dispatch);
  const userActions = createUserActions(state, dispatch);
  const petCollectionActions = createPetCollectionActions(state, dispatch);
  const challengeActions = createChallengeActions(state, dispatch);
  const statsActions = createStatsActions(state, dispatch, setAppState);
  const prizeActions = createPrizeActions(state, dispatch);
  const habiticaActions = createHabiticaActions(state, dispatch);
  const pledgeBasedPetActions = createPledgeBasedPetActions(state, dispatch);

  return {
    ...activityActions,
    ...userActions,
    ...petCollectionActions,
    ...challengeActions,
    ...statsActions,
    ...prizeActions,
    ...habiticaActions,
    ...pledgeBasedPetActions,
  };
};
